export enum InvoiceAppearance {
    Paper,
    Electronic,
    Edi,
    Unknown
}